(() => {
  if (window.cgmMorganaCta) return;
  window.cgmMorganaCta = true;
  if (location.pathname.includes('preventivo-fotovoltaico-morgana')) return;
  function strip() {
    if (document.querySelector('.cgm-morgana-strip')) return;
    const hg = document.getElementById('header-group');
    if (!hg) return;
    const a = document.createElement('a');
    a.className = 'cgm-morgana-strip';
    a.href = '/pages/preventivo-fotovoltaico-morgana';
    a.setAttribute('aria-label', 'Preventivo fotovoltaico con Morgana');
    a.innerHTML = '<span aria-hidden="true">☀</span><span>Preventivo con Morgana</span><span class="cgm-morgana-strip__go">Clicca qui ›</span>';
    hg.insertAdjacentElement('afterend', a);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', strip, { once: true });
  else strip();
})();
